import { keyframes, css } from 'styled-components';
import colors from './colors';

export const pulse = keyframes`
    0% { transform: scale(1); }
    35% { transform: scale(1.1); }
    100% { transform: scale(1); }
`;

export const bounceKeyframes = keyframes`
    0%,
    80%,
    100% { transform: scale(0) }
    40% { transform: scale(1.0) }
`;

export const shimmer = keyframes`
   100% {
			transform: translateX(100%);
		}
`;

export const blink = keyframes`
  0%, 100% {
    opacity: 0;
  }
  50% {
    opacity: 1;
  }
`;

export const slideUp = keyframes`
  from {
    opacity: 0;
    transform: translateY(4px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

export const skeletonAnimation = (backgroundColor = colors.gray100) => css`
  position: relative;
  overflow: hidden;

  &:before {
    z-index: 10;
    background-color: ${backgroundColor};
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 100%;
    position: absolute;
    content: '';
  }

  &:after {
    z-index: 10;
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 100%;
    transform: translateX(-100%);
    background-image: linear-gradient(
      90deg,
      rgba(255, 255, 255, 0) 0,
      rgba(255, 255, 255, 0.2) 20%,
      rgba(255, 255, 255, 0.5) 60%,
      rgba(255, 255, 255, 0)
    );
    animation: ${shimmer} 1.2s infinite;
    content: '';
  }
`;
